import { resolveUrl } from "../../../utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export async function apiMarkNotificationsAsInteracted() {
  const url = resolveUrl(`/notifications/interact-with-notifications`);

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  return await response.json();
}
